/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from './jsonable';

export class JsonApiListResourceMetadataBase extends JSONable {
  totalSize = 0;
}
